import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/PC.png")